import LoadingInView from './LoadingInView';

export default LoadingInView;
